import AdvanceFilter from './advance_filter/AdvanceFilter';
import BandsFilter from './BandsFilter';
import './CustomFilter.scss'
import Search from './Search'
import TctmFilter from './TctmFilter'
import TimeInputFilter from './TimeInputFilter'
import { AdvanceFilterProps, AllFilterType } from './types';

interface CustomFilterProps {
    alignment?: 'left' | 'right';
    bandsFilter?: {
        bands: {
            label: string;
            value: string;
        }[];
        applyFilter: (filters: AllFilterType) => void;
        onClick: (bandKey: string) => void;
    };
    tctmFilter?: {
        tctms: {
            label: string;
            value: string;
            Icon: React.ReactNode;
        }[];
        onClick: (tctm: string) => void;
        applyFilter: (filters: AllFilterType) => void;
    };
    timeFilter?: {
        applyFilter: (filters: AllFilterType) => void;
    };
    search?: {
        applyFilter: (filters: AllFilterType) => void;
        placeholder?: string;
    };
    advanceFilter?: AdvanceFilterProps;
    allFilters: AllFilterType;
    setAllFilters: React.Dispatch<React.SetStateAction<AllFilterType>>;
    filterCase: string;
    boundingScreen: string;
    timeRange?: {
        start: number;
        end: number
    }
}

const CustomFilter = ({ alignment, bandsFilter, tctmFilter, timeFilter, search, advanceFilter, allFilters, setAllFilters, filterCase, boundingScreen, timeRange }: CustomFilterProps) => {

    return (
        <div className={`custom__filter__container align__${alignment}`}>
            {bandsFilter && <BandsFilter {...bandsFilter} allFilters={allFilters} setAllFilters={setAllFilters} />}
            {tctmFilter && <TctmFilter {...tctmFilter} allFilters={allFilters} setAllFilters={setAllFilters} />}
            {timeFilter && <TimeInputFilter range={timeRange} {...timeFilter} allFilters={allFilters} setAllFilters={(filters) => { setAllFilters(filters) }} />}
            {search && <Search {...search} allFilters={allFilters} setAllFilters={setAllFilters} />}
            {advanceFilter && <AdvanceFilter {...advanceFilter} allFilters={allFilters} setAllFilters={setAllFilters} filterCase={filterCase} boundingScreen={boundingScreen} />}
        </div>
    )
}

export default CustomFilter